import { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import SatAPI from "../../_services/sat";
import toastService from "../../_services/toastService";

const api = SatAPI();

function EditModalPreferenceScores({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [preferenceScoreHigh, setPreferenceScoreHigh] = useState(data.preferenceScoreHigh ?? 7);
  const [preferenceScoreLow, setPreferenceScoreLow] = useState(data.preferenceScoreLow ?? 4);

  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      await api.updateGlobalSettings({
        ...data,
        preferenceScoreHigh,
        preferenceScoreLow,
      });
      toastService.send({ title: "Success", message: "Drempelwaarden opgeslagen" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "Fout", message: `${error}` });
    }
  };

  return (
    <Modal show onHide={hideModal} backdrop="static" keyboard={false} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Drempelwaarden voorkeuren bewerken</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <span className="text-success fw-bold">Hoge voorkeur</span> groen vanaf
                </Form.Label>
                <Form.Control
                  type="number"
                  min={1}
                  max={10}
                  required
                  value={preferenceScoreHigh}
                  onChange={e => setPreferenceScoreHigh(parseInt(e.target.value, 10))}
                />
                <Form.Text className="text-muted">Score ≥ deze waarde wordt groen weergegeven.</Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <span className="text-warning fw-bold">Neutrale voorkeur</span> oranje vanaf
                </Form.Label>
                <Form.Control
                  type="number"
                  min={1}
                  max={10}
                  required
                  value={preferenceScoreLow}
                  onChange={e => setPreferenceScoreLow(parseInt(e.target.value, 10))}
                />
                <Form.Text className="text-muted">Score ≥ deze waarde en &lt; hoge drempel wordt oranje. Daaronder rood.</Form.Text>
              </Form.Group>

              <Button variant="primary" type="submit" disabled={snapshot}>
                <i className="far fa-edit" />&nbsp;Bewerk
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EditModalPreferenceScores;
